import { render, staticRenderFns } from "./KiesFoto.vue?vue&type=template&id=1ebde348"
import script from "./KiesFoto.vue?vue&type=script&lang=js"
export * from "./KiesFoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports